module.exports = __webpack_public_path__ + "img/20190702161208006.56d3a2f9.png";